import { API_URL } from "./http";

const getAllEvents=()=>`${API_URL}/placement-officer/current/events`;
const getRegisteredStudents=(eventId,searchValue,filterValue)=>`${API_URL}/placement-officer/current/events/${eventId}/students?searchTerm=${searchValue}&membershipStatus=${filterValue}`
const ApproveStudent=(eventId)=>`${API_URL}/placement-officer/current/events/${eventId}/students/status`
const createEvent=()=>`${API_URL}/placement-officer/current/events`;
const updateEvent=(id)=>`${API_URL}/placement-officer/current/events/${id}`
const getStudentById=(eventId,studentId)=>`${API_URL}/placement-officer/current/events/${eventId}/students/${studentId}`
const getStudentJobsbyId=(eventId,studentId)=>`${API_URL}/placement-officer/current/events/${eventId}/students/${studentId}/jobs/applied`
const getEmployerById=(eventId,employerId)=>`${API_URL}/placement-officer/current/events/${eventId}/employers/${employerId}`
const getEmployerjobs=(eventId,employerId)=>`${API_URL}/placement-officer/current/events/${eventId}/employers/${employerId}/jobs?jobStatus=PUBLISH&`
const ApproveEmployer=(eventId)=>`${API_URL}/placement-officer/current/events/${eventId}/employers/status`
const getRegisteredEmployers=(eventId,searchValue,filterValue)=>`${API_URL}/placement-officer/current/events/${eventId}/employers?searchTerm=${searchValue}&membershipStatus=${filterValue}`
const deleteEvent=(id)=>`${API_URL}/placement-officer/current/events/${id}`
const getAllJobs=(eventId)=>`${API_URL}/placement-officer/current/events/${eventId}/jobs?status=PUBLISH&`
const getJobById=(eventId,jobId)=>`${API_URL}/placement-officer/current/events/${eventId}/jobs/${jobId}`
const getReportOfStudent=(eventId,searchValue,status,id)=>`${API_URL}/placement-officer/current/events/${eventId}/job-applications/report?searchTerm=${searchValue}&status=${status}&jobId=${id}`
const getProfile=()=> `${API_URL}/placement-officer/current/profile`

export default {
    getAllEvents,
    createEvent,
    getRegisteredStudents,
    ApproveStudent,
    updateEvent,
    getStudentById,
    ApproveEmployer,
    getRegisteredEmployers,
    deleteEvent,
    getEmployerById,
    getEmployerjobs,
    getAllJobs,
    getStudentJobsbyId,
    getReportOfStudent,
    getJobById,
    getProfile
}